import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getModel = (modelId: number | undefined): Promise<IGetModel> => {
  return axiosDefaultApi.get(`/api/Models/GetModelViaID/${modelId}`);
};

type QueryFnType = typeof getModel;

type UseGetModelOptions = {
  modelId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetModel = ({ modelId , config }: UseGetModelOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getModel_${modelId}`],
    queryFn: () => getModel(modelId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Τύπου Συσκευής.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};